import { Appointment } from "@elixir/types";
import { getIdb, updateAppointment } from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import getB from "../../utils/bridges/EkaBridge";
import {
  AptActivityType,
  trackAppointmentActivity,
} from "./appointment-activity";

export default async function submitCustomFieldValue({
  appointment,
  fieldId,
  fieldValues,
}: {
  appointment: Pick<Appointment, "aid" | "apt_fields">;
  fieldId: string;
  fieldValues: Array<string>;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    const apt = await getIdb().appointments.get(aid);

    const filteredAptFields = (
      apt?.apt_fields ||
      appointment.apt_fields ||
      []
    ).filter((aptField) => aptField.field_id !== fieldId);

    await updateAppointment({
      data: {
        apt_fields: [
          ...filteredAptFields,
          { field_id: fieldId, values: fieldValues },
        ],
      },
      aid,
    });

    trackAppointmentActivity({
      aid,
      activity: AptActivityType.SUBMIT_CUSTOM_FIELD,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
